import {
  H2 as BluBlocksH2,
  H3 as BluBlocksH3,
  SubtitleH2 as BluBlocksSubtitleH2,
  SubtitleH3 as BluBlocksSubtitleH3
} from "@bluframe/blublocks"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

export const H2 = styled(BluBlocksH2)`
  font-size: 18px;
  margin: 0;
`

export const SubtitleH2 = styled(BluBlocksSubtitleH2)`
  font-size: 16px;
  margin: 0;
`

export const ImageAndRules = styled.div<{ $hasImage: boolean }>`
  align-items: center;
  column-gap: 20px;
  display: grid;
  ${({ $hasImage }) => ($hasImage ? "grid-template-columns: 120px 1fr;" : "")}

  ${mediaQueries.tablet} {
    column-gap: 40px;
    ${({ $hasImage }) => ($hasImage ? "grid-template-columns: 180px 1fr;" : "")}
  }
`

export const Image = styled.img``

export const Inputs = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr auto auto auto 1fr;
  justify-items: start;
  row-gap: 20px;
`

export const InputAndImage = styled.div`
  display: grid;
  row-gap: 20px;
`

export const InputsRules = styled.div`
  display: grid;
  row-gap: 10px;
`

export const Preview = styled.div``

export const UsersCount = styled.div`
  display: grid;
  justify-items: end;
  justify-self: end;
  row-gap: 2px;
`

export const EnrolledUsersCount = styled(BluBlocksH3)`
  font-size: 18px;
  margin: 0;
`

export const OptedOutUsersCount = styled(BluBlocksSubtitleH3)`
  font-size: 16px;
  margin: 0;
`
